import { Reveal, PageShell } from "@/components/Reveal";

const sections = [
  {
    title: "1. Verantwortliche",
    blocks: [
      { type: "p", text: "Verantwortlich für die Verarbeitung personenbezogener Daten auf dieser Website ist:" },
      {
        type: "address",
        lines: [
          "Carmen Hackradt",
          "Sehestedter Str. 10",
          "24340 Eckernförde",
          "Deutschland",
          "Telefon: 0162 8564347",
          "E-Mail: kontakt@carmenhackradt.de",
        ],
      },
    ],
  },
  {
    title: "2. Allgemeine Hinweise zur Datenverarbeitung",
    blocks: [
      { type: "p", text: "Der Schutz deiner persönlichen Daten ist mir wichtig. Ich verarbeite personenbezogene Daten nur im Rahmen der geltenden datenschutzrechtlichen Bestimmungen, insbesondere der Datenschutz-Grundverordnung (DSGVO) und des Telekommunikation-Digitale-Dienste-Datenschutz-Gesetzes (TDDDG)." },
      { type: "p", text: "Personenbezogene Daten sind Informationen, mit denen du persönlich identifiziert werden kannst oder die sich auf dich beziehen." },
      { type: "p", text: "Ich verarbeite personenbezogene Daten insbesondere, wenn du diese Website besuchst, mit mir Kontakt aufnimmst oder externe Inhalte wie Google Maps oder YouTube aktivierst." },
    ],
  },
  {
    title: "3. Aufruf der Website und Server-Logdaten",
    blocks: [
      { type: "p", text: "Beim Aufruf dieser Website werden durch den technischen Betrieb der Website möglicherweise automatisch Informationen verarbeitet, die dein Browser an den Server übermittelt." },
      { type: "p", text: "Hierzu können insbesondere gehören:" },
      {
        type: "list",
        items: [
          "IP-Adresse",
          "Datum und Uhrzeit des Zugriffs",
          "aufgerufene Seiten bzw. Dateien",
          "Browsertyp und Browserversion",
          "verwendetes Betriebssystem",
          "Referrer-URL",
          "technische Informationen zur Nutzung der Website",
        ],
      },
      { type: "p", text: "Die Verarbeitung erfolgt, um die Website technisch bereitzustellen, ihre Sicherheit und Stabilität zu gewährleisten und Fehler zu erkennen." },
      { type: "p", text: "Die Verarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO aufgrund meines berechtigten Interesses an einem sicheren und funktionsfähigen Betrieb der Website." },
      { type: "p", text: "Die Website wird technisch über Emergent bereitgestellt. Die Domain und das E-Mail-Postfach werden über IONOS verwaltet." },
      { type: "p", text: "Die konkreten technischen Logdaten und Speicherfristen richten sich nach den jeweiligen technischen Einstellungen und den Datenschutzbedingungen der eingesetzten Hosting-Anbieter." },
    ],
  },
  {
    title: "4. Kontaktaufnahme per Kontaktformular",
    blocks: [
      { type: "p", text: "Auf meiner Website besteht die Möglichkeit, über ein Kontaktformular mit mir Kontakt aufzunehmen." },
      { type: "p", text: "Dabei werden folgende Angaben verarbeitet:" },
      { type: "list", items: ["Name", "E-Mail-Adresse", "Nachricht"] },
      { type: "p", text: "Alle genannten Felder sind Pflichtfelder." },
      { type: "p", text: "Die von dir eingegebenen Daten werden verwendet, um deine Anfrage zu bearbeiten und mit dir Kontakt aufzunehmen." },
      { type: "p", text: "Die Nachricht wird an meine E-Mail-Adresse kontakt@carmenhackradt.de übermittelt und dort verarbeitet." },
      { type: "p", text: "Die Verarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO, soweit deine Anfrage auf die Anbahnung oder Durchführung eines Vertragsverhältnisses gerichtet ist, beziehungsweise auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO bei allgemeinen Anfragen. Mein berechtigtes Interesse besteht in der Bearbeitung und Beantwortung von Kontaktanfragen." },
      { type: "p", text: "Bitte übermittle über das Kontaktformular möglichst keine besonders sensiblen Informationen, insbesondere keine ausführlichen Angaben zu Krankheiten oder anderen Gesundheitsdaten, sofern diese für deine Anfrage nicht erforderlich sind." },
      { type: "p", text: "Die Daten werden gelöscht, sobald die Anfrage abschließend bearbeitet wurde und keine gesetzlichen Aufbewahrungspflichten oder sonstigen rechtlichen Gründe für eine weitere Speicherung bestehen." },
    ],
  },
  {
    title: "5. Kontaktaufnahme per E-Mail oder Telefon",
    blocks: [
      { type: "p", text: "Wenn du mich per E-Mail oder telefonisch kontaktierst, werden die von dir übermittelten personenbezogenen Daten verarbeitet, soweit dies zur Bearbeitung deiner Anfrage erforderlich ist." },
      { type: "p", text: "Bei einer Kontaktaufnahme per E-Mail wird insbesondere deine E-Mail-Adresse sowie der Inhalt deiner Nachricht verarbeitet." },
      { type: "p", text: "Bei einer Kontaktaufnahme per Telefon kann insbesondere deine Telefonnummer sowie die von dir während des Gesprächs mitgeteilten Informationen verarbeitet werden." },
      { type: "p", text: "Die Verarbeitung erfolgt je nach Inhalt und Zweck der Anfrage auf Grundlage von Art. 6 Abs. 1 lit. b oder lit. f DSGVO." },
    ],
  },
  {
    title: "6. Terminvereinbarung",
    blocks: [
      { type: "p", text: "Termine können über die auf der Website angegebenen Kontaktmöglichkeiten vereinbart werden." },
      { type: "p", text: "Es wird hierfür kein externer Online-Kalender oder Buchungsdienst eingesetzt." },
      { type: "p", text: "Eine Terminvereinbarung erfolgt insbesondere über das Kontaktformular, per E-Mail oder telefonisch." },
      { type: "p", text: "Die dabei übermittelten Daten werden ausschließlich zur Bearbeitung der Terminanfrage und zur Durchführung bzw. Vorbereitung des vereinbarten Termins verarbeitet." },
    ],
  },
  {
    title: "7. Cookies und Einwilligungsverwaltung",
    blocks: [
      { type: "p", text: "Diese Website verwendet technisch notwendige Technologien, die für den Betrieb der Website erforderlich sind." },
      { type: "p", text: "Darüber hinaus können externe Inhalte von Drittanbietern eingebunden werden, insbesondere:" },
      { type: "list", items: ["Google Maps", "YouTube"] },
      { type: "p", text: "Beim erstmaligen Besuch der Website wird dir eine Auswahlmöglichkeit über die Verwendung nicht notwendiger Technologien angezeigt." },
      { type: "p", text: "Du kannst dabei insbesondere zwischen notwendigen Technologien und externen Medien wählen." },
      { type: "p", text: "Nicht notwendige externe Inhalte werden grundsätzlich erst geladen, nachdem du hierfür deine Einwilligung erteilt hast." },
      { type: "p", text: "Deine Einwilligungsentscheidung wird gespeichert, damit sie bei späteren Besuchen berücksichtigt werden kann." },
      { type: "p", text: "Du kannst deine Einwilligung jederzeit über die Cookie-Einstellungen ändern oder widerrufen." },
      { type: "p", text: "Die Verarbeitung aufgrund einer Einwilligung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO. Die Speicherung bzw. der Zugriff auf Informationen auf deinem Endgerät richtet sich zusätzlich nach § 25 TDDDG." },
    ],
  },
  {
    title: "8. Google Maps",
    blocks: [
      { type: "p", text: "Auf der Kontaktseite dieser Website ist eine Karte von Google Maps eingebunden." },
      { type: "p", text: "Anbieter ist:" },
      {
        type: "address",
        lines: ["Google Ireland Limited", "Gordon House, Barrow Street", "Dublin 4", "Irland"],
      },
      { type: "p", text: "Google Maps wird verwendet, um den Standort von Carmen Hackradt darzustellen und Besuchern die Orientierung bzw. Anfahrt zu erleichtern." },
      { type: "p", text: "Die Google-Maps-Karte wird so eingebunden, dass eine Verbindung zu Google grundsätzlich erst hergestellt wird, nachdem du der Verwendung externer Medien zugestimmt hast." },
      { type: "p", text: "Bei Aktivierung von Google Maps können insbesondere deine IP-Adresse sowie technische Informationen an Google übertragen werden. Dabei kann eine Verarbeitung personenbezogener Daten durch Google stattfinden." },
      { type: "p", text: "Weitere Informationen findest du in der Datenschutzerklärung von Google." },
    ],
  },
  {
    title: "9. YouTube",
    blocks: [
      { type: "p", text: "Auf dieser Website werden Videos von YouTube eingebunden." },
      { type: "p", text: "Anbieter ist:" },
      {
        type: "address",
        lines: ["Google Ireland Limited", "Gordon House, Barrow Street", "Dublin 4", "Irland"],
      },
      { type: "p", text: "Die Videos wurden von Carmen Hackradt selbst erstellt und über ihren YouTube-Account bereitgestellt." },
      { type: "p", text: "Die YouTube-Videos werden erst nach entsprechender Einwilligung zur Nutzung externer Medien geladen." },
      { type: "p", text: "Bei Aktivierung eines YouTube-Videos wird eine Verbindung zu den Servern von YouTube hergestellt. Dabei können personenbezogene Daten, insbesondere technische Informationen und die IP-Adresse, an Google übertragen werden." },
      { type: "p", text: "Weitere Informationen zur Datenverarbeitung durch Google findest du in den Datenschutzbestimmungen von Google." },
    ],
  },
  {
    title: "10. Google Fonts",
    blocks: [
      { type: "p", text: "Auf dieser Website können Schriftarten verwendet werden, die ursprünglich aus dem Angebot von Google Fonts stammen." },
      { type: "p", text: "Die technische Einbindung wird so vorgenommen, dass die Schriftarten möglichst lokal auf dem Server der Website bereitgestellt werden und keine unnötige Verbindung zu Google-Servern allein zum Laden der Schriftarten hergestellt wird." },
      { type: "p", text: "Sollten Schriftarten entgegen dieser vorgesehenen Konfiguration extern von Google geladen werden, wird die Datenschutzerklärung entsprechend angepasst." },
    ],
  },
  {
    title: "11. Instagram",
    blocks: [
      { type: "p", text: "Auf dieser Website befindet sich ein Link zu Instagram." },
      { type: "p", text: "Beim bloßen Aufruf der Website wird kein Instagram-Feed und kein Instagram-Plugin eingebunden." },
      { type: "p", text: "Wenn du den Instagram-Link anklickst, verlässt du diese Website und wirst zu Instagram weitergeleitet." },
      { type: "p", text: "Für die anschließende Datenverarbeitung durch Instagram bzw. Meta gelten die Datenschutzbestimmungen des jeweiligen Anbieters." },
    ],
  },
  {
    title: "12. Fotos auf der Website",
    blocks: [
      { type: "p", text: "Auf dieser Website werden Fotos von Carmen Hackradt sowie gegebenenfalls Fotos verwendet, auf denen andere Personen abgebildet sind." },
      { type: "p", text: "Die Veröffentlichung solcher Fotos erfolgt auf Grundlage einer entsprechenden rechtlichen Erlaubnis, insbesondere einer Einwilligung der abgebildeten Personen, soweit diese erforderlich ist." },
      { type: "p", text: "Solltest du dich auf einem veröffentlichten Foto wiedererkennen und der Veröffentlichung widersprechen wollen, kannst du dich an die oben genannte Kontaktadresse wenden." },
    ],
  },
  {
    title: "13. Empfänger personenbezogener Daten",
    blocks: [
      { type: "p", text: "Personenbezogene Daten können im Rahmen des Websitebetriebs insbesondere durch folgende Kategorien von Empfängern bzw. Dienstleistern verarbeitet werden:" },
      {
        type: "list",
        items: [
          "technische Hosting-/Infrastrukturdienstleister",
          "E-Mail-Dienstleister",
          "Anbieter externer Inhalte wie Google Maps und YouTube, soweit du deren Aktivierung zustimmst",
        ],
      },
      { type: "p", text: "Eine Weitergabe personenbezogener Daten zu Werbezwecken erfolgt nicht." },
    ],
  },
  {
    title: "14. Datenübermittlung in Drittländer",
    blocks: [
      { type: "p", text: "Durch die Nutzung bestimmter Dienste von Google, insbesondere Google Maps und YouTube, kann eine Verarbeitung personenbezogener Daten auch außerhalb der Europäischen Union bzw. des Europäischen Wirtschaftsraums stattfinden." },
      { type: "p", text: "Eine solche Verarbeitung erfolgt nach den jeweils geltenden datenschutzrechtlichen Voraussetzungen und auf Grundlage der von Google bereitgestellten geeigneten Garantien, soweit erforderlich." },
    ],
  },
  {
    title: "15. Dauer der Speicherung",
    blocks: [
      { type: "p", text: "Personenbezogene Daten werden nur so lange gespeichert, wie dies für den jeweiligen Zweck erforderlich ist." },
      { type: "p", text: "Darüber hinaus kann eine Speicherung erfolgen, wenn gesetzliche Aufbewahrungspflichten bestehen oder die Daten zur Durchsetzung, Ausübung oder Verteidigung von Rechtsansprüchen benötigt werden." },
      { type: "p", text: "Nach Wegfall des jeweiligen Verarbeitungszwecks bzw. Ablauf gesetzlicher Aufbewahrungsfristen werden die Daten gelöscht, sofern keine andere rechtliche Grundlage für eine weitere Speicherung besteht." },
    ],
  },
  {
    title: "16. Deine Rechte",
    blocks: [
      { type: "p", text: "Du hast nach Maßgabe der gesetzlichen Voraussetzungen insbesondere folgende Rechte:" },
      {
        type: "list",
        items: [
          "Recht auf Auskunft über die zu deiner Person gespeicherten Daten",
          "Recht auf Berichtigung unrichtiger personenbezogener Daten",
          "Recht auf Löschung deiner personenbezogenen Daten",
          "Recht auf Einschränkung der Verarbeitung",
          "Recht auf Datenübertragbarkeit",
          "Recht auf Widerspruch gegen bestimmte Verarbeitungen",
          "Recht auf Widerruf einer erteilten Einwilligung",
        ],
      },
      { type: "p", text: "Wenn eine Verarbeitung auf deiner Einwilligung beruht, kannst du diese Einwilligung jederzeit mit Wirkung für die Zukunft widerrufen. Die Rechtmäßigkeit der bis zum Widerruf erfolgten Verarbeitung bleibt davon unberührt." },
      { type: "p", text: "Zur Ausübung deiner Rechte genügt eine Nachricht an: kontakt@carmenhackradt.de" },
    ],
  },
  {
    title: "17. Beschwerderecht bei einer Aufsichtsbehörde",
    blocks: [
      { type: "p", text: "Du hast das Recht, dich bei einer Datenschutzaufsichtsbehörde über die Verarbeitung deiner personenbezogenen Daten zu beschweren." },
      { type: "p", text: "Zuständig kann insbesondere die Datenschutzaufsichtsbehörde des Bundeslandes sein, in dem Carmen Hackradt ihren Wohn- bzw. Geschäftssitz hat." },
      { type: "p", text: "Für Schleswig-Holstein ist dies das:" },
      {
        type: "address",
        lines: [
          "Unabhängige Landeszentrum für Datenschutz Schleswig-Holstein (ULD)",
          "Holstenstraße 98",
          "24103 Kiel",
          "Deutschland",
        ],
      },
    ],
  },
  {
    title: "18. Keine automatisierte Entscheidungsfindung",
    blocks: [
      { type: "p", text: "Eine automatisierte Entscheidungsfindung einschließlich Profiling im Sinne von Art. 22 DSGVO findet im Rahmen dieser Website nicht statt." },
    ],
  },
  {
    title: "19. Aktualität dieser Datenschutzerklärung",
    blocks: [
      { type: "p", text: "Diese Datenschutzerklärung kann angepasst werden, wenn sich die technische Gestaltung der Website, die verwendeten Dienste oder die rechtlichen Anforderungen ändern." },
      { type: "p", text: "Es gilt jeweils die auf dieser Website veröffentlichte aktuelle Fassung." },
    ],
  },
];

const Block = ({ block }) => {
  if (block.type === "list") {
    return (
      <ul className="list-disc space-y-1.5 pl-6 text-base leading-relaxed text-anthrazit/85">
        {block.items.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
    );
  }
  if (block.type === "address") {
    return (
      <p className="text-base leading-relaxed text-anthrazit/85">
        {block.lines.map((line, index) => (
          <span key={line}>
            {line}
            {index < block.lines.length - 1 && <br />}
          </span>
        ))}
      </p>
    );
  }
  return <p className="text-base leading-relaxed text-anthrazit/85">{block.text}</p>;
};

export default function Datenschutz() {
  return (
    <PageShell testid="datenschutz-page">
      <header
        data-testid="datenschutz-hero"
        className="px-6 pb-12 pt-36 md:px-12 md:pb-16 md:pt-52"
      >
        <div className="mx-auto max-w-3xl">
          <p className="mb-6 text-xs uppercase tracking-[0.4em] text-anthrazit/60">
            Dein Körper spricht mit dir
          </p>
          <h1 className="font-serif text-5xl leading-[0.95] tracking-tight text-anthrazit md:text-7xl">
            Datenschutz
          </h1>
        </div>
      </header>
      <section data-testid="datenschutz-content" className="px-6 pb-32 md:px-12 md:pb-44">
        <div className="mx-auto max-w-3xl">
          <Reveal>
            <h2 className="font-serif text-2xl tracking-tight text-anthrazit md:text-3xl">
              Datenschutzerklärung
            </h2>
            <p
              data-testid="datenschutz-stand"
              className="mt-2 text-sm uppercase tracking-[0.2em] text-anthrazit/55"
            >
              Stand: September 2026
            </p>
          </Reveal>
          <div className="mt-14 space-y-12">
            {sections.map((section) => (
              <Reveal key={section.title}>
                <section data-testid={`datenschutz-section-${section.title.split(".")[0]}`}>
                  <h3 className="mb-4 font-serif text-xl tracking-tight text-anthrazit md:text-2xl">
                    {section.title}
                  </h3>
                  <div className="space-y-4">
                    {section.blocks.map((block, index) => (
                      <Block key={index} block={block} />
                    ))}
                  </div>
                </section>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </PageShell>
  );
}
